import { createStore } from 'vuex';
import user from '@/store/modules/user';
import market from "@/store/modules/market";
import pageTemplates from "@/store/modules/pageTemplates";
import page from "@/store/modules/page";
import indesign from "@/store/modules/indesign";
import settings from "@/store/modules/settings";
import team from "@/store/modules/team";

export default createStore({
    modules: {
        user,
        market,
        pageTemplates,
        page,
        indesign,
        settings,
        team,
    },
    state() {
        return {
            pagePosition: null,
            magazineId: null,
            pageId: null,
            productId: null,
            productTemplateId: null,
            marketId: null,
            accordionIndex: null,
            placeholderSize: {
                width: 0.0,
                height: 0.0
            },
            magazinePagePositions: [],
        };
    },
    mutations: {
        setMagazinePagePositions(state, payload) {
            state.magazinePagePositions = payload;
        },
        setPageId(state, payload) {
            state.pageId = payload;
        },
        setProductTemplateId(state, payload) {
            state.productTemplateId = payload;
        },
        setProductId(state, payload) {
            state.productId = payload;
        },
        setMarketId(state, payload) {
            state.marketId = payload;
        },
        setAccordionIndex(state, payload) {
            state.accordionIndex = payload;
        },
        setPagePosition(state, payload) {
            state.pagePosition = payload;
        },
        setMagazineId(state, payload) {
            state.magazineId = payload;
        },
        setPlaceholderSize(state, payload) {
            state.placeholderSize.height = payload?.height || 0.0
            state.placeholderSize.width = payload?.width || 0.0;
        }
    },
    actions: {

    },
    getters: {

    }
});
